export const REQUEST_CLIENTDASHBOARD_DATA = 'REQUEST_CLIENTDASHBOARD_DATA';
export const CLIENTDASHBOARD_DATA_RECEIVED = 'CLIENTDASHBOARD_DATA_RECEIVED';